import { useState } from "react";
import type { FormEvent } from "react";

import { ApiError } from "./api";
import { useAuth } from "./auth";
import { PRODUCT_NAME } from "./product";

export function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username, password);
    } catch (caught) {
      setError(
        caught instanceof ApiError && caught.status === 401
          ? "Invalid credentials or account locked."
          : "Sign-in failed. Try again or contact the platform administrator.",
      );
      setPassword("");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <h1>{PRODUCT_NAME}</h1>
      <form onSubmit={onSubmit} aria-label="Sign in">
        <label>
          Username
          <input
            name="username"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </label>
        <label>
          Password
          <input
            name="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error && <p role="alert">{error}</p>}
        <button type="submit" disabled={busy}>
          Sign in
        </button>
      </form>
    </main>
  );
}
